import React from "react";

// shared components
import {Typography} from "../../../../designSystem/components/Typography";
import {DashboardCard} from "../../../../designSystem/components/DashboardCard";

// models
import {getSeverityCategory} from "../../model/severity";
import {QUESTIONS} from "../../model/questions";
import {SEVERITY_LABELS} from '../../model/scale';

interface BsrsFormResultViewProps {
  score: number;
  answers: number[],
  showDetail?: boolean
}

export const BsrsFormResultView = ({
  score,
  answers,
  showDetail = true
}: BsrsFormResultViewProps) => {
  const severityCategory = getSeverityCategory(score);
  return (
    <DashboardCard>
      <Typography variant="subtitle">
        BSRS-5 簡短健康量表結果
      </Typography>

      {/* Score Badge */}
      <div className="flex flex-col justify-between items-start gap-4">
        <div className={`
        text-white font-bold px-4 py-2 rounded-md inline-block
          ${severityCategory.color}
        `}>
          總分: {score}
        </div>
        <Typography variant="body">
          {answers[5] > 2 ? '建議尋求身心醫療專業協助' : severityCategory.label }
        </Typography>
      </div>

      {showDetail ?
        <React.Fragment>
          <hr className="my-4"/>
          <div className="flex flex-col gap-8">
            {QUESTIONS.map((question, index) => (
              <div key={index} className="flex flex-col gap-1">
                <Typography variant="bodyBold">
                  {question}
                </Typography>
                <Typography variant="body">
                  ➤ {SEVERITY_LABELS[answers[index]]}
                </Typography>
              </div>
            ))}
          </div>
        </React.Fragment>
        : null
      }
    </DashboardCard>
  );
};
